import request from '@/utils/request'

const url = 'index.php/temporary/api/temp/'

export function GetDataByListApplet(query) {
    return request({
        url: url +'InstQuestionErrorCommon/GetDataByListApplet',
        method: 'get',
        params: query
    })
}


export function GetItemByUserId(query) {
    return request({
        url: url +'GetItemByUserId',
        method: 'get',
        params: query
    })
}



